import { Container } from "react-bootstrap";
import MainMenu from "../../../modules/public/mainMenu/mainMenu";
import { RiCheckboxCircleFill } from "react-icons/ri";
import { Box, Unstable_Grid2 as Grid } from "@mui/material";
import Overview from "../../../components/overview/Overview";
import { useQuery } from "@tanstack/react-query";
import { getAuthMethod } from "../../../modules/helper";

export default function DigikalaCoworkerToday() {
  const { data } = useQuery({
    queryKey: ["DigikalaCoworkerToday"],
    queryFn: () =>
      getAuthMethod("/v1/digikala/coworker/today").then(res => {
        if (res && res.status === 200) {
          return res.data.data;
        }

        return { all: 0 };
      }),

    refetchOnWindowFocus: false,
    placeholderData: { all: 0 },
  });

  return (
    <MainMenu>
      <Container>
        <h4 className="mt-4">
          امروز : {new Date().toLocaleDateString("fa-IR")}
        </h4>
        <Box sx={{ display: "flex", flexDirection: "row" }} className="mt-5">
          <Grid xs={12} sm={6} lg={3}>
            <Overview
              positive
              sx={{
                height: "100%",
                boxShadow: "0 0 5px 3px #00000036",
                padding: 1.1,
                "& > div > div > div:nth-of-type(2)": {
                  marginLeft: 0,
                  marginRight: 6,
                },
              }}
              value={data.all}
              title="ثبت شده"
              backgroundColor="success.main"
            >
              <RiCheckboxCircleFill />
            </Overview>
          </Grid>
        </Box>
      </Container>
    </MainMenu>
  );
}
